import { addDays, addMonths, addWeeks, addYears } from "date-fns";
import type { FollowUpPreset } from "@/lib/activitySettingsSchema";

export function dateFromFollowUpPreset(preset: FollowUpPreset, from: Date = new Date()): Date {
  switch (preset) {
    case "1d":
      return addDays(from, 1);
    case "3d":
      return addDays(from, 3);
    case "1w":
      return addWeeks(from, 1);
    case "2w":
      return addWeeks(from, 2);
    case "1m":
      return addMonths(from, 1);
    case "3m":
      return addMonths(from, 3);
    case "6m":
      return addMonths(from, 6);
    case "1y":
      return addYears(from, 1);
    default:
      return addMonths(from, 3);
  }
}

export const FOLLOW_UP_PRESET_OPTIONS: { value: FollowUpPreset; label: string }[] = [
  { value: "1d", label: "Em 1 dia" },
  { value: "3d", label: "Em 3 dias" },
  { value: "1w", label: "Em 1 semana" },
  { value: "2w", label: "Em 2 semanas" },
  { value: "1m", label: "Em 1 mês" },
  { value: "3m", label: "Em 3 meses" },
  { value: "6m", label: "Em 6 meses" },
  { value: "1y", label: "Em 1 ano" },
];
